var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "50px",
    height: "25px",
    viewBox: "0 0 50 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 25,
    style: {
      fill: "rgb(69.803922%,13.333333%,20.392157%)",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      strokeWidth: 300,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0 449.71875 L 7410 449.71875 M 7410 1049.953125 L 0 1049.953125 M 0 1650.1875 L 7410 1650.1875 M 7410 2249.8125 L 0 2249.8125 M 0 2850.046875 L 7410 2850.046875 M 7410 3450.28125 L 0 3450.28125 ",
    transform: "matrix(0.00674764,0,0,0.00641026,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(23.529412%,23.137255%,43.137255%)",
      fillOpacity: 1
    },
    d: "M 0 0 L 20 0 L 20 13.460938 L 0 13.460938 Z M 0 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.667969 0.578125 L 2.144531 1.96875 L 0.898438 1.109375 L 2.4375 1.109375 L 1.191406 1.96875 Z M 1.667969 0.578125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.667969 3.269531 L 2.144531 4.660156 L 0.898438 3.800781 L 2.4375 3.800781 L 1.191406 4.660156 Z M 1.667969 3.269531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.667969 5.960938 L 2.144531 7.351562 L 0.898438 6.492188 L 2.4375 6.492188 L 1.191406 7.351562 Z M 1.667969 5.960938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.667969 8.652344 L 2.144531 10.046875 L 0.898438 9.183594 L 2.4375 9.183594 L 1.191406 10.046875 Z M 1.667969 8.652344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.667969 11.347656 L 2.144531 12.738281 L 0.898438 11.878906 L 2.4375 11.878906 L 1.191406 12.738281 Z M 1.667969 11.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.332031 1.921875 L 3.808594 3.316406 L 2.5625 2.453125 L 4.101562 2.453125 L 2.855469 3.316406 Z M 3.332031 1.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.332031 4.617188 L 3.808594 6.007812 L 2.5625 5.148438 L 4.101562 5.148438 L 2.855469 6.007812 Z M 3.332031 4.617188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.332031 7.308594 L 3.808594 8.699219 L 2.5625 7.839844 L 4.101562 7.839844 L 2.855469 8.699219 Z M 3.332031 7.308594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.332031 10 L 3.808594 11.390625 L 2.5625 10.53125 L 4.101562 10.53125 L 2.855469 11.390625 Z M 3.332031 10 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5 0.578125 L 5.476562 1.96875 L 4.230469 1.109375 L 5.769531 1.109375 L 4.523438 1.96875 Z M 5 0.578125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5 3.269531 L 5.476562 4.660156 L 4.230469 3.800781 L 5.769531 3.800781 L 4.523438 4.660156 Z M 5 3.269531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5 5.960938 L 5.476562 7.351562 L 4.230469 6.492188 L 5.769531 6.492188 L 4.523438 7.351562 Z M 5 5.960938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5 8.652344 L 5.476562 10.046875 L 4.230469 9.183594 L 5.769531 9.183594 L 4.523438 10.046875 Z M 5 8.652344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5 11.347656 L 5.476562 12.738281 L 4.230469 11.878906 L 5.769531 11.878906 L 4.523438 12.738281 Z M 5 11.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.667969 1.921875 L 7.144531 3.316406 L 5.898438 2.453125 L 7.4375 2.453125 L 6.191406 3.316406 Z M 6.667969 1.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.667969 4.617188 L 7.144531 6.007812 L 5.898438 5.148438 L 7.4375 5.148438 L 6.191406 6.007812 Z M 6.667969 4.617188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.667969 7.308594 L 7.144531 8.699219 L 5.898438 7.839844 L 7.4375 7.839844 L 6.191406 8.699219 Z M 6.667969 7.308594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.667969 10 L 7.144531 11.390625 L 5.898438 10.53125 L 7.4375 10.53125 L 6.191406 11.390625 Z M 6.667969 10 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.332031 0.578125 L 8.808594 1.96875 L 7.5625 1.109375 L 9.101562 1.109375 L 7.855469 1.96875 Z M 8.332031 0.578125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.332031 3.269531 L 8.808594 4.660156 L 7.5625 3.800781 L 9.101562 3.800781 L 7.855469 4.660156 Z M 8.332031 3.269531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.332031 5.960938 L 8.808594 7.351562 L 7.5625 6.492188 L 9.101562 6.492188 L 7.855469 7.351562 Z M 8.332031 5.960938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.332031 8.652344 L 8.808594 10.046875 L 7.5625 9.183594 L 9.101562 9.183594 L 7.855469 10.046875 Z M 8.332031 8.652344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.332031 11.347656 L 8.808594 12.738281 L 7.5625 11.878906 L 9.101562 11.878906 L 7.855469 12.738281 Z M 8.332031 11.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10 1.921875 L 10.476562 3.316406 L 9.230469 2.453125 L 10.769531 2.453125 L 9.523438 3.316406 Z M 10 1.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10 4.617188 L 10.476562 6.007812 L 9.230469 5.148438 L 10.769531 5.148438 L 9.523438 6.007812 Z M 10 4.617188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10 7.308594 L 10.476562 8.699219 L 9.230469 7.839844 L 10.769531 7.839844 L 9.523438 8.699219 Z M 10 7.308594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10 10 L 10.476562 11.390625 L 9.230469 10.53125 L 10.769531 10.53125 L 9.523438 11.390625 Z M 10 10 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.667969 0.578125 L 12.144531 1.96875 L 10.898438 1.109375 L 12.4375 1.109375 L 11.191406 1.96875 Z M 11.667969 0.578125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.667969 3.269531 L 12.144531 4.660156 L 10.898438 3.800781 L 12.4375 3.800781 L 11.191406 4.660156 Z M 11.667969 3.269531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.667969 5.960938 L 12.144531 7.351562 L 10.898438 6.492188 L 12.4375 6.492188 L 11.191406 7.351562 Z M 11.667969 5.960938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.667969 8.652344 L 12.144531 10.046875 L 10.898438 9.183594 L 12.4375 9.183594 L 11.191406 10.046875 Z M 11.667969 8.652344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.667969 11.347656 L 12.144531 12.738281 L 10.898438 11.878906 L 12.4375 11.878906 L 11.191406 12.738281 Z M 11.667969 11.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 13.332031 1.921875 L 13.808594 3.316406 L 12.5625 2.453125 L 14.101562 2.453125 L 12.855469 3.316406 Z M 13.332031 1.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 13.332031 4.617188 L 13.808594 6.007812 L 12.5625 5.148438 L 14.101562 5.148438 L 12.855469 6.007812 Z M 13.332031 4.617188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 13.332031 7.308594 L 13.808594 8.699219 L 12.5625 7.839844 L 14.101562 7.839844 L 12.855469 8.699219 Z M 13.332031 7.308594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 13.332031 10 L 13.808594 11.390625 L 12.5625 10.53125 L 14.101562 10.53125 L 12.855469 11.390625 Z M 13.332031 10 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15 0.578125 L 15.476562 1.96875 L 14.230469 1.109375 L 15.769531 1.109375 L 14.523438 1.96875 Z M 15 0.578125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15 3.269531 L 15.476562 4.660156 L 14.230469 3.800781 L 15.769531 3.800781 L 14.523438 4.660156 Z M 15 3.269531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15 5.960938 L 15.476562 7.351562 L 14.230469 6.492188 L 15.769531 6.492188 L 14.523438 7.351562 Z M 15 5.960938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15 8.652344 L 15.476562 10.046875 L 14.230469 9.183594 L 15.769531 9.183594 L 14.523438 10.046875 Z M 15 8.652344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15 11.347656 L 15.476562 12.738281 L 14.230469 11.878906 L 15.769531 11.878906 L 14.523438 12.738281 Z M 15 11.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.667969 1.921875 L 17.144531 3.316406 L 15.898438 2.453125 L 17.4375 2.453125 L 16.191406 3.316406 Z M 16.667969 1.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.667969 4.617188 L 17.144531 6.007812 L 15.898438 5.148438 L 17.4375 5.148438 L 16.191406 6.007812 Z M 16.667969 4.617188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.667969 7.308594 L 17.144531 8.699219 L 15.898438 7.839844 L 17.4375 7.839844 L 16.191406 8.699219 Z M 16.667969 7.308594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.667969 10 L 17.144531 11.390625 L 15.898438 10.53125 L 17.4375 10.53125 L 16.191406 11.390625 Z M 16.667969 10 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.332031 0.578125 L 18.808594 1.96875 L 17.5625 1.109375 L 19.101562 1.109375 L 17.855469 1.96875 Z M 18.332031 0.578125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.332031 3.269531 L 18.808594 4.660156 L 17.5625 3.800781 L 19.101562 3.800781 L 17.855469 4.660156 Z M 18.332031 3.269531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.332031 5.960938 L 18.808594 7.351562 L 17.5625 6.492188 L 19.101562 6.492188 L 17.855469 7.351562 Z M 18.332031 5.960938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.332031 8.652344 L 18.808594 10.046875 L 17.5625 9.183594 L 19.101562 9.183594 L 17.855469 10.046875 Z M 18.332031 8.652344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.332031 11.347656 L 18.808594 12.738281 L 17.5625 11.878906 L 19.101562 11.878906 L 17.855469 12.738281 Z M 18.332031 11.347656 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/usa.8f71c4f0691cb920358dac78d11f1e71.svg";
export { ForwardRef as ReactComponent };